import { render, staticRenderFns } from "./fullRead.vue?vue&type=template&id=30f1ae1a&"
import script from "./fullRead.vue?vue&type=script&lang=js&"
export * from "./fullRead.vue?vue&type=script&lang=js&"
import style0 from "./fullRead.vue?vue&type=style&index=0&id=30f1ae1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports